<template>
  <div class="container">
    <!-- 顶部导航栏组件 -->
    <Titles></Titles>
    <div class="box">
      <!-- 广告位 -->
      <advertisement />
      <!-- 头部菜单组件 -->
      <InteriorH :name="3"></InteriorH>
      <!-- <p>调解指南</p> -->

      <!-- 指南列表 -->
      <div class="list" v-for="(item, index) in list" :key="index" @click="path(item.id, item.category_id)">
        {{ }}
        <img :src="item.thumbImage.fullImageUrl" alt="">
        <div class="listBox">
          <h5>
            {{ item.title }}
          </h5>
          <span>{{ item.create_time }}</span>
        </div>
      </div>

      <!-- 分页 -->
      <!-- <van-pagination @change="log" v-model="currentPage" :total-items="50" :items-per-page="5" :show-page-size="5">
      </van-pagination> -->
      <van-pagination @change="onChange" v-model="currentPage" :total-items="total" :show-page-size="10"></van-pagination>
    </div>
    <copyright />
  </div>
</template>

<script>
import Titles from '../components/title.vue'
import InteriorH from '../components/interiorH.vue'
import copyright from '../components/copyright.vue'

import axios from 'axios'
export default {
  components: {
    Titles,
    InteriorH,
    copyright,
  },
  data() {
    return {
      currentPage: 1,
      upper: '上',
      text: 5,
      total: "",
      list: []

      // {
      //   fullImageUrl:"",
      //   title:"",
      //   post_time:""
      // }
    }
  },
  mounted() {
    this.grtlist()
  },
  methods: {
    // category_id是类型
    async grtlist(value = 1) {
      let res = await axios.post('/api/article/page_list', {
        "current_page": value,
        "category_id": 4
      })
      this.list = res.data.data.records
      this.total = res.data.data.total
    },
    onChange(value) {
      this.grtlist(value);
    },
    // 跳转到详情
    path(article_id, category_id) {
      // console.log(value);
      this.$router.push({ path: "/fingerpostI", query: { article_id, category_id } })
    },
  },

}
</script>

<style scoped>
.box {
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding: 3rem 1rem 0 1rem;

}

p {
  width: 100%;
  height: 13.5rem;
  border-radius: 0.5rem;
  margin-top: 2.375rem;
  position: relative;
}

.list {
  width: 100%;
  height: 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}

.list img {
  width: 101px;
  height: 72px;
}

.listBox {
  width: calc(100% - 118px);
  height: 72px;
  /* width: 274px; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.listBox span {
  text-align: right;
  font-size: 12px;
  color: #94979A;
}

/* >>>样式穿透报错怎么解决 */
>>>.van-pagination__item--active {
  color: black;
  background-color: #fff;
}

>>>.van-pagination__item:active {
  color: #1989fa;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/page/JudgmentCase.vue